import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.THEME.black};
  padding: 32px;
  border-radius: 16px;
  max-width: 400px;
  width: 90%;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 80vh;
  overflow-y: auto;
  padding-bottom: 80px;

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.THEME.neonBlue} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.THEME.neonBlue};
    border-radius: 10px;
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const ModalContentWrapper = styled.div`
  background: ${({ theme }) => theme.THEME.black};
  padding: 32px;
  border-radius: 16px;
  max-width: 400px;
  width: 90%;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  position: relative;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const ScrollableContent = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.THEME.neonBlue} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.THEME.neonBlue};
    border-radius: 10px;
  }
`;

export const ModalTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 30}px;
  color: ${({ theme }) => theme.THEME.neonBlue};
  margin-bottom: 16px;
  text-align: center;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const ModalField = styled.label`
  font-size: 14px;
  margin-top: 16px;
  display: block;
  color: ${({ theme }) => theme.THEME.white};
`;

export const StyledInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.THEME.grayText};
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  padding: 6px 4px;
  margin-bottom: 12px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 80px;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.THEME.grayText};
  color: ${({ theme }) => theme.THEME.white};
  font-size: 16px;
  padding: 6px 4px;
  margin-bottom: 12px;
  resize: none;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }
`;

export const AddButton = styled.button`
  margin: 16px auto;
  display: block;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme }) => theme.THEME.white};
  background: transparent;
  border: 1px solid ${({ theme }) => theme.THEME.neonBlue};
  border-radius: 20px;
  padding: 6px 14px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: ${({ theme }) => theme.THEME.neonBlue};
    color: ${({ theme }) => theme.THEME.black};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: none;
    color: ${({ theme }) => theme.THEME.grayText};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const MultiItemWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

  &:last-of-type {
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH}px;
  }
`;

export const FixedFooter = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;
